module.exports = __webpack_public_path__ + "static/google-play-button-f868e0b2919ca49817279b6dd075847b.svg";